module.exports = __webpack_public_path__ + "p3_img4.jpg?a31999f6304ee8984d432e0d3952a66b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p3/p3_img4.jpg
// module id = 106
// module chunks = 0